var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "selfordering-login" },
    [
      !_vm.isLoggedIn
        ? [
            _c("FormLogin", {
              ref: "loginForm",
              on: { loggedIn: _vm.onLoggedIn },
            }),
            _vm._v(" "),
            _c("FormRegister", { ref: "registerForm", attrs: { phone: "" } }),
          ]
        : _vm.showPhoneForm
        ? [
            _c("h2", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("account.selfordering.addPhoneTitle")),
              },
            }),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("account.selfordering.addPhoneText")),
              },
            }),
            _vm._v(" "),
            _c("ValidationObserver", {
              ref: "phoneForm",
              attrs: { tag: "form", novalidate: "" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.onPhoneUpdate.apply(null, arguments)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var invalid = ref.invalid
                    var errors = ref.errors
                    return [
                      _vm.phoneResponse.message
                        ? _c("GeneralMessage", {
                            attrs: {
                              message: _vm.phoneResponse.message,
                              type: _vm.phoneResponse.type,
                            },
                            on: {
                              close: function ($event) {
                                _vm.phoneResponse.message = ""
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("ValidationProvider", {
                        staticClass: "input-wrapper",
                        attrs: {
                          name: "phone",
                          rules: "required|phone_int",
                          tag: "div",
                          customMessages: {
                            required: _vm.$t("forms.errors.fieldEmpty"),
                            phone_int: _vm.$t("forms.errors.phone"),
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                var invalid = ref.invalid
                                var validated = ref.validated
                                return [
                                  _c("FormInput", {
                                    attrs: {
                                      type: "tel",
                                      placeholder: _vm.$t("forms.labels.phone"),
                                      label: _vm.$t("forms.labels.phone"),
                                      name: "phone",
                                      error: errors.length > 0,
                                      "error-message": errors[0],
                                      hint: _vm.$t("login.phoneHint"),
                                      required: "",
                                    },
                                    model: {
                                      value: _vm.phoneForm.phoneNumber,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.phoneForm,
                                          "phoneNumber",
                                          $$v
                                        )
                                      },
                                      expression: "phoneForm.phoneNumber",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c("Button", {
                        attrs: {
                          type: "submit",
                          level: "primary",
                          text: _vm.$t("account.safeButton"),
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ]
        : _c(
            "div",
            { staticClass: "selfordering-login__details" },
            [
              _c("h2", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("account.selfordering.qrcodeTitle")),
                },
              }),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("account.selfordering.qrcodeText")),
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "selfordering-login__user" },
                [
                  _c("div", {
                    staticClass: "selfordering-login__user-name",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.accountUserDetail.firstName +
                          " " +
                          _vm.accountUserDetail.lastName
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "selfordering-login__user-email",
                    domProps: {
                      innerHTML: _vm._s(_vm.accountUserDetail.email),
                    },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "selfordering-login__user-phone",
                    domProps: {
                      innerHTML: _vm._s(_vm.accountUserDetail.phoneNumber),
                    },
                  }),
                  _vm._v(" "),
                  this.accountUserDetail.phoneNumber
                    ? _c("Button", {
                        attrs: {
                          level: "tertiary",
                          type: "button",
                          text: _vm.$t(
                            "account.selfordering.changePhoneButton"
                          ),
                          arrow: "",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.onPhoneChange.apply(null, arguments)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("QRCode", { attrs: { content: _vm.accountQrTokenPrefixed } }),
              _vm._v(" "),
              _c("SVGScanIllustrationPhone"),
            ],
            1
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }